/* eslint-disable no-unused-vars */
import axios from 'axios'
import stringutil from './stringutil.js';
import dateutil from './dateutil.js';
const request = function(row) {
    var userInfo = this.getLocalStorageAndTime('userInfo') || '';
    let tokenId;
    if(userInfo != ''){
        tokenId = userInfo.data.tokenId
    }
    return {
        "header": {
            "requestId": stringutil.getRandomNumber(32),
            "timeStamp": new Date().format('yyyyMMddhhmmss'),
            "applicationId": "groupbuy-web",
            "ip": "127.0.0.1",
            "tokenId": tokenId
        },
        "body": row
    }
}
const setObject = function(key, value) {
    value = JSON.stringify(value)
    return localStorage.setItem(key, value)
}
const getObject = function(key) {
    return JSON.parse(window.localStorage.getItem(key));
}
const setsessionStorage = function(key, value) {
    value = JSON.stringify(value)
    return sessionStorage.setItem(key, value)
}
const getsessionStorage = function(key) {
    return JSON.parse(window.sessionStorage.getItem(key));
}

const setLocalStorageAndTime = function(key, value) {
    window.localStorage.setItem(key, JSON.stringify({ data: value, time: new Date().getTime() }))
}

const getLocalStorageAndTime = function(key, exp = 86400000) {
    // 获取数据
    let data = window.localStorage.getItem(key)
    if (!data) return null
    let dataObj = JSON.parse(data)
    // 与过期时间比较
    if (new Date().getTime() - dataObj.time > exp) {
        // 过期删除返回null
        localStorage.removeItem(key)
        console.log('信息已过期')
        return null
    } else {
        return dataObj.data
    }
}
// const getAddressFn = function(lat,lng){
//     let qqMapKey = 'CYLBZ-Z7IW6-PAFSJ-M4SX5-5K7R6-EABP4';
//     axios.get('https://apis.map.qq.com/ws/geocoder/v1/?location='+lat+','+lng+'&key='+qqMapKey,)
//     .then(res => {
//        console.log(res)
//     }, error => {
//         // this.$Message.error('');
//         console.log(error);
//     })
// }
export default {
    request,
    setObject,
    getObject,
    setsessionStorage,
    getsessionStorage,
    setLocalStorageAndTime,
    getLocalStorageAndTime,
    // getAddressFn
}